import React from "react";
import "./ContactUs.css";
import { FaPhoneAlt, FaEnvelope, FaMapMarkerAlt } from "react-icons/fa";

const ContactUs = () => {
  return (
    <div className="contactus-page">
      {/* Hero */}
      <section className="contactus-hero">
        <h1>Let’s Connect</h1>
        <p>We’re here to answer your questions and help your business grow.</p>
      </section>

      {/* Info Cards */}
      <section className="contactus-info">
        <div className="contactus-card">
          <img src="/Images/operator.png" className="contactus-icon" />
          <h3>Call Us</h3>
          <p style={{marginBottom:'0px'}}>+93 77 989 7682</p>
           <p>+1 (516) 690-5802</p>
        </div>
        <div className="contactus-card">
          <img src="/Images/contact-us.png" className="contactus-icon" />
          <h3>Email Us</h3>
          <p>support@abasinexpress.com</p>
        </div>
        <div className="contactus-card">
          <img src="/Images/location-pin.png" className="contactus-icon" />
          <h3>Kabul Office</h3>
          <p>Ansari Square, Shahr-e-naw, Kabul, Afghanistan</p>
        </div>
          <div className="contactus-card">
          <img src="/Images/location-pin.png" className="contactus-icon" />
          <h3>USA Office</h3>
          <p>67 Hillwood Dr, Huntington Station,NY 11746</p>
        </div>
      </section>

      {/* Form + Map */}
      <section className="contactus-form-section">
        <div className="contactus-form">
          <h2>Send a Message</h2>
          <p>Fill out the form and our team will get back to you shortly.</p>
          <form>
            <input type="text" placeholder="Your Name" required />
            <input type="email" placeholder="Email Address" required />
            <input type="tel" placeholder="Phone Number" required />
            <textarea placeholder="Your Message" rows="5" required></textarea>
            <button type="submit">Submit</button>
          </form>
        </div>

        <div className="contactus-map">
          <iframe
            title="location"
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d25856.374879914615!2d69.16770112999583!3d34.52263191161261!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x38d1e8c6a3c5f5f5%3A0x8b2d3c7f7d1c1a2b!2sAnsari%20Square%2C%20Shahr-e-Naw%2C%20Kabul%2C%20Afghanistan!5e0!3m2!1sen!2sus!4v1694515200000!5m2!1sen!2sus"
            allowFullScreen=""
            loading="lazy"
          ></iframe>
        </div><div className="contactus-map">
         <iframe
  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d486.3215432381608!2d-73.4267948509725!3d40.85201527175858!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89e8285d86a8d827%3A0xb3c8d20e53356b6f!2s67%20Hillwood%20Dr%2C%20Huntington%20Station%2C%20NY%2011746%2C%20USA!5e0!3m2!1sen!2sin!4v1781335303424!5m2!1sen!2sin"

  allowFullScreen=""
  loading="lazy"
  referrerPolicy="no-referrer-when-downgrade"
/>

        </div>

        
      </section>
    </div>
  );
};

export default ContactUs;
